import { render, staticRenderFns } from "./InspectionScoreList.vue?vue&type=template&id=f61ac4bc"
import script from "./InspectionScoreList.vue?vue&type=script&lang=js"
export * from "./InspectionScoreList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports